import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { SidebarService } from 'src/app/core/services/sidebar.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-hr-page-header',
  templateUrl: './hr-page-header.component.html',
  styleUrls: ['./hr-page-header.component.css']
})
export class HrPageHeaderComponent implements OnInit, OnDestroy {

  // Input properties for customization
  @Input() heading: any = 'Default Heading';
  @Input() searchPlaceholder: string = 'Search';
  @Input() addButtonText: string = 'Add';
  @Input() exportButtonText: string = 'Export';
  @Input() showAddButton: boolean = true;
  @Input() showExportButton: boolean = true;
  @Input() showFilterIcon: boolean = true;
  @Input() initialSearchQuery: string = '';
  @Input() searchReadonly: boolean = true;

  // Output events
  @Output() searchInput = new EventEmitter<string>();
  @Output() searchFocus = new EventEmitter<void>();
  @Output() addClick = new EventEmitter<void>();
  @Output() exportClick = new EventEmitter<void>();
  @Output() filterClick = new EventEmitter<void>();

  // Component properties
  searchQuery: string = '';
  isSidebarCollapsed: boolean = false;
  private sidebarSubscription!: Subscription;
  private dialogOpenedSub?: Subscription;
  private dialogClosedSub?: Subscription;
  dialogOpen: boolean = false;

  constructor(private sidebarService: SidebarService, private matDialog: MatDialog) { }

  ngOnInit(): void {
    this.searchQuery = this.initialSearchQuery;
    // Subscribe to sidebar state changes
    this.sidebarSubscription = this.sidebarService.collapsed$.subscribe(collapsed => {
      this.isSidebarCollapsed = collapsed;
    });
    // Listen for global dialog open/close to disable search while dialog is open
    this.dialogOpenedSub = this.matDialog.afterOpened.subscribe(() => {
      this.dialogOpen = true;
    });
    this.dialogClosedSub = this.matDialog.afterAllClosed.subscribe(() => {
      this.dialogOpen = false;
    });
  }

  ngOnDestroy(): void {
    if (this.sidebarSubscription) {
      this.sidebarSubscription.unsubscribe();
    }
    if (this.dialogOpenedSub) {
      this.dialogOpenedSub.unsubscribe();
    }
    if (this.dialogClosedSub) {
      this.dialogClosedSub.unsubscribe();
    }
  }

  onSearchInput(event: any): void {
    this.searchQuery = event.target.value;
    this.searchInput.emit(this.searchQuery);
  }

  onSearchFocus(): void {
    if (!this.dialogOpen) {
      this.searchFocus.emit();
    }
  }

  onAddClick(): void {
    this.addClick.emit();
  }

  onExportClick(): void {
    this.exportClick.emit();
  }

  onFilterClick(): void {
    this.filterClick.emit();
  }
}